module.exports = __webpack_public_path__ + "static/media/icon-visa.3b392fab.png";